import { registerImages } from '@bonanza-social/moonlight';
import landingPage from './images/landingPage';
import coinsImages from './images/coins';
import miscImages from './images/responsibleGaming';
import { ImageSource } from 'react-native';

const images = { ...coinsImages, ...miscImages };

registerImages('misc', images);
registerImages('landingPage', landingPage);

declare global {
  interface RegisteredImages {
    misc: Record<keyof typeof images, ImageSource>;
    landingPage: Record<keyof typeof landingPage, ImageSource>;
  }
}
